<template>
  <div id="Admin_DetailFinancialTable">
    <!-- 銷帳明細表 -->
    <div
      id="sales_detail"
      class="tab-pane fade show active"
      role="tabpanel"
      aria-labelledby="sales_detail"
    >
      <div class="col-12 pt-2 table-style">
        <!-- 功能欄 -->
        <v-query-layout>
          <!-- 1 -->
          <v-label
            slot="ql1-text-1"
            for="query-keyword"
            LabText="篩選資料："
            Labbold="true"
          />
          <input
            id="query-keyword"
            class="input-style"
            type="text"
            slot="ql1-input-1"
            placeholder="請輸入關鍵字"
            v-model="filter"
          >
          <v-label
            slot="ql1-text-2"
            for="query-paytype"
            class="ml-2"
            LabText="繳費管道："
            Labbold="true"
          />
          <select
            id="query-paytype"
            class="input-style"
            slot="ql1-input-2"
            v-model="QueryDetail.PayApproach"
          >
            <option
              value=""
              disabled
            >
              -請選擇-
            </option>
            <option
              v-for="Pay in PayApproachSelect"
              :key="Pay.id"
              :value="Pay.value"
            >
              {{ Pay.text }}
            </option>
          </select>
          <!-- 2 -->
          <v-label
            slot="ql2-text-1"
            for="query-on"
            LabText="銷帳批號："
            Labbold="true"
          />
          <input
            id="query-on"
            class="input-style"
            type="text"
            slot="ql2-input-1"
            placeholder="請輸入銷帳批號"
            v-model="QueryDetail.DebtConfirmNo"
          >
          <v-label
            slot="ql2-text-2"
            class="ml-2"
            LabText="入帳日期："
            Labbold="true"
          />
          <a-locale-provider
            slot="ql2-input-2"
            :locale="zhTW"
          >
            <a-date-picker
              size="large"
              @change="onDebtDate"
              :format="dateFormat"
              v-model="timeDebtDate"
            />
          </a-locale-provider>
          <!-- 3 -->
          <v-label
            slot="ql3-text-1"
            LabText="繳費時間(起)："
            Labbold="true"
          />
          <a-locale-provider
            slot="ql3-input-1"
            :locale="zhTW"
          >
            <a-date-picker
              size="large"
              @change="onPayDTStart"
              :format="dateFormat"
              v-model="timePayDTStart"
            />
          </a-locale-provider>
          <v-label
            slot="ql3-text-2"
            class="ml-2"
            LabText="繳費時間(迄)："
            Labbold="true"
          />
          <a-locale-provider
            slot="ql3-input-2"
            :locale="zhTW"
          >
            <a-date-picker
              size="large"
              @change="onPayDTEnd"
              :format="dateFormat"
              v-model="timePayDTEnd"
            />
          </a-locale-provider>
          <div slot="qcbutton3">
            <v-button
              class="ml-2"
              btn-text="查詢"
              btnOutline="primary"
              @click.native="InquireFeeitemQuery"
            >
              <font-awesome-icon
                slot="icon"
                icon="search"
              />
            </v-button>
            <v-button
              class="ml-2"
              btn-text="清除"
              btnOutline="secondary"
              @click.native="ClearCondition"
            >
              <font-awesome-icon
                slot="icon"
                icon="search-minus"
              />
            </v-button>
          </div>
          <!-- 4 -->
          <v-label
            slot="ql4-text-1"
            LabText="功能："
            Labbold="true"
          />
          <div slot="ql4-input-1">
            <v-button
              btn-text="入帳"
              title="入帳"
              btnType="primary"
              @click.native="CheckReportDebtconfirm"
            >
              <font-awesome-icon
                slot="icon"
                icon="edit"
                size="sm"
              />
            </v-button>
            <v-button
              class="ml-2"
              btn-text="匯出報表"
              title="匯出報表"
              btnType="warning"
              data-toggle="modal"
              data-target="#export"
            >
              <font-awesome-icon
                slot="icon"
                icon="chart-bar"
                size="sm"
              />
            </v-button>
          </div>
          <v-label
            slot="ql4-text-2"
            for="query-page"
            class="ml-2"
            LabText="筆數："
            Labbold="true"
          />
          <v-page
            slot="ql4-input-2"
            id="query-page"
            @RecPerPage="RecPerPage"
          />
        </v-query-layout>
        <hr>
        <!-- 表格內容 -->
        <template>
          <span class="word-bold mb-2">
            總金額：{{ TotalAmt }} 元
          </span>
          <span class="word-bold mb-2 ml-4">
            手續費總金額：{{ ChargeTotalAmt }} 元
          </span>
          <br>
          <v-button
            class="mt-2 mr-2 mb-2"
            btn-text="全選"
            btnOutline="primary"
            btnSize="sm"
            :disabled="items.length === 0"
            @click.native="selectAllRows"
          />
          <v-button
            class="mt-2 mb-2"
            btn-text="清除選擇"
            btnOutline="primary"
            btnSize="sm"
            @click.native="clearSelected"
          />
          <v-button
            class="mt-2 mb-2 ml-2"
            btn-text="手續費|備註變更"
            btnOutline="info"
            btnSize="sm"
            @click.native="PostReportChargerevise"
          />
          <b-table
            id="b-table"
            hover
            small
            bordered
            responsive
            ref="selectableTable"
            selectable
            :select-mode="selectMode"
            selected-variant="success"
            @row-selected="onRowSelected"
            @row-clicked="rowClicked"
            style="position: relative;"
            :items="items"
            :filter="filter"
            :fields="fields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :current-page="currentPage"
            :sort-direction="sortDirection"
            :tbody-tr-class="tbodyRowClass"
            @filtered="onFiltered"
            primary-key="SerialNo"
          >
            <!-- 繳款項目所屬人 -->
            <template v-slot:cell(UserName)="data">
              <span class="nukWord">
                {{ data.item.UserName }}
              </span>
            </template>
            <!-- 收據抬頭 -->
            <template v-slot:cell(ReceiptTitle)="data">
              <span class="nukWord">
                {{ data.item.ReceiptTitle }}
              </span>
            </template>
            <!-- 繳款日期 -->
            <template v-slot:cell(PayDT)="data">
              {{ date(data.item.PayDT) }}
            </template>
            <!-- 繳款項目狀態 -->
            <template v-slot:cell(FeeOrderStatus)="data">
              <div
                v-if="data.item.FeeOrderStatus == 2"
              >
                已繳費
              </div>
              <div
                v-if="data.item.FeeOrderStatus == 3"
              >
                已入帳
              </div>
            </template>
            <!-- 繳費金額 -->
            <template v-slot:cell(PayAmt)="data">
              {{ data.item.PayAmt + ' 元' }}
            </template>
            <!-- 手續費 -->
            <template v-slot:cell(PayCharge)="data">
              <input
                style="text"
                class="input-style"
                v-model.number="data.item.PayCharge"
                @click="GetCharge(data.item.SerialNo)"
              >
            </template>
            <!-- 繳款項目入帳備註 -->
            <template v-slot:cell(DebtRemark)="data">
              <input
                style="text"
                class="input-style"
                v-model="data.item.DebtRemark"
                maxlength="5"
                @click="GetCharge(data.item.SerialNo)"
              >
            </template>
            <!-- 選擇功能 -->
            <template v-slot:cell(selected)="data">
              <template v-if="data.item.No === true">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">選取</span>
              </template>
              <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">取消</span>
              </template>
            </template>
          </b-table>
          <br>
          <!-- 分頁 -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0 mb-2"
          />
        </template>
      </div>
      <br>
    </div>
    <!-- 入帳Model -->
    <v-modal id="Debt">
      <div slot="header">
        入帳資訊
      </div>
      <div slot="body">
        <div class="container">
          <div class="row">
            <div class="col-4 text-right">
              <v-label
                Labbold="true"
                LabText="入帳總金額:"
              />
            </div>
            <div class="col-8">
              {{ TotalAmt + '元' }}
            </div>
          </div>
          <div class="row">
            <div class="col-4 text-right">
              <v-label
                Labbold="true"
                LabText="繳費通路:"
              />
            </div>
            <div class="col-8">
              <div
                v-for="Pay in PayApproachSelect"
                :key="Pay.id"
                :value="Pay.value"
              >
                <span v-if="QueryDetail.PayApproach === Pay.value">
                  {{ Pay.text }}
                </span>
              </div>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-4 text-right">
              <v-label
                Labbold="true"
                LabText="入帳日期:"
              />
            </div>
            <div class="col-8">
              <a-locale-provider :locale="zhTW">
                <a-date-picker
                  size="large"
                  @change="oncheckDate"
                  :defaultValue="moment(checkDate, dateFormat)"
                  :format="dateFormat"
                />
              </a-locale-provider>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-4 text-right">
              <v-label
                for="DebtRemark"
                Labbold="true"
                LabText="入帳備註:"
              >
                <span slot="small">
                  繳款項目<br>
                </span>
              </v-label>
            </div>
            <div class="col-8">
              <textarea
                id="DebtRemark"
                class="form-control"
                rows="3"
                placeholder="若填入備註說明，將註記至所有繳款項目，可填入空白表不修改"
                v-model="DebtRemark"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-4 text-right">
              <v-label
                for="ReceiptDebt"
                Labbold="true"
                LabText="(虛擬收據編號):"
              >
                <span slot="small">
                  入帳收據編號<br>
                </span>
              </v-label>
            </div>
            <div class="col-8">
              <input
                id="ReceiptDebt"
                class="input-style"
                type="text"
                v-model="ReceiptDebt"
              >
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <v-button
          btn-text="確認入帳"
          btnType="primary"
          @click.native="PostReportDebtconfirm"
        />
        <v-button
          class="ml-1"
          btn-text="取消"
          btnType="secondary"
          data-dismiss="modal"
          aria-label="Close"
        />
      </div>
    </v-modal>
    <!-- 匯出Model -->
    <v-modal id="export">
      <div slot="header">
        匯出報表
      </div>
      <div slot="body">
        <div>
          <label for="DebtConfirmNos">
            請輸入銷帳批號:
          </label>
          <input
            id="DebtConfirmNos"
            class="input-style ml-2"
            type="text"
            v-model="Detailexport"
          >
        </div>
      </div>
      <div slot="footer">
        <v-button
          btn-text="確認匯出"
          btnType="primary"
          @click.native="PostReportDetailexport"
        />
        <v-button
          class="ml-1"
          btn-text="取消"
          btnType="secondary"
          data-dismiss="modal"
          aria-label="Close"
        />
      </div>
    </v-modal>
    <!-- 入帳完成Model -->
    <v-modal id="NewDebtConfirmNo">
      <div slot="header">
        入帳成功
      </div>
      <div slot="body">
        銷帳批號：
        <span id="CopyDebtConfirmNo">
          {{ NewDebtConfirmNo }}
        </span>
        <br>
        <v-button
          btn-text="點我複製"
          btnType="info"
          btnSize="sm"
          v-clipboard:copy="NewDebtConfirmNo"
        />
      </div>
      <div slot="footer">
        <v-button
          btn-text="確認"
          btnType="primary"
          data-dismiss="modal"
          aria-label="Close"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import $ from 'jquery'
import md5 from 'js-md5'
import moment from 'moment'
import vLabel from '@/components/Features/Label'
import vModal from '@/components/Features/ModalFloot'
import vQueryLayout from '@/components/Layout/QueryLayout'
import { apiReportQuerydetail, apiReportDebtconfirm, apiReportDetailexport, apiReportChargerevise } from '../../../Api/api'
import 'ant-design-vue/lib/date-picker/style/css'
import zhTW from 'ant-design-vue/lib/locale-provider/zh_TW'
export default {
  components: {
    'v-modal': vModal,
    'v-label': vLabel,
    'v-query-layout': vQueryLayout
  },
  name: 'Admin_DetailFinancialTable',
  data () {
    return {
      items: [],
      fields: [
        { key: 'selected', label: '選取', thClass: 'table-th' },
        { key: 'SerialNo', label: '#', thClass: 'table-th' },
        { key: 'AccountingTitle', label: '會計科目', thClass: 'table-th' },
        { key: 'ProjectNumber', label: '計畫編號', thClass: 'table-th' },
        { key: 'FeeItemId', label: '收費項目編號', thClass: 'table-th' },
        { key: 'FeeItemName', label: '收費項目名稱', stickyColumn: true, isRowHeader: true, thClass: 'table-th', variant: 'info' },
        { key: 'FeeOrderDesc', label: '繳款項目說明事由', thClass: 'table-th' },
        { key: 'FeeOrderId', label: '繳款項目編號', thClass: 'table-th' },
        { key: 'PayOrderId', label: '繳費單號', thClass: 'table-th' },
        { key: 'PayDT', label: '繳款日期', thClass: 'table-th', sortable: true },
        { key: 'DebtConfirmNo', label: '銷帳批號', thClass: 'table-th' },
        { key: 'UserName', label: '繳款項目所屬人', thClass: 'table-th' },
        { key: 'ReceiptTitle', label: '收據抬頭', thClass: 'table-th' },
        { key: 'CompanyTaxId', label: '公司統編', thClass: 'table-th' },
        { key: 'PayAmt', label: '繳費金額', thClass: 'table-th', sortable: true, variant: 'warning' },
        { key: 'PayCharge', label: '手續費金額', thClass: 'table-th' },
        { key: 'DebtRemark', label: '繳款項目入帳備註', thClass: 'table-th' },
        { key: 'FeeOrderStatus', label: '繳款項目狀態', thClass: 'table-th' },
        { key: 'TransactionId', label: 'LINE交易編號', thClass: 'table-th' },
        { key: 'LINEOrderId', label: 'LINE訂單編號', thClass: 'table-th' }
      ],
      selectMode: 'multi',
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      PayApproachSelect: [
        { value: 'C', text: '信用卡' },
        { value: 'I', text: '一卡通' },
        { value: 'L', text: 'LINE Pay' },
        { value: 'B', text: '土地銀行' },
        { value: 'H', text: '現金' }
      ],
      QueryDetail: {
        DebtConfirmNo: '',
        DebtDate: '',
        PayApproach: '',
        PayDTStart: '',
        PayDTEnd: ''
      },
      Charge: [],
      AddCharge: [],
      Detailexport: '',
      DebtData: {},
      QueryData: {},
      TotalAmt: 0,
      ChargeTotalAmt: 0,
      DebtRemark: '',
      ReceiptDebt: '',
      zhTW,
      dateFormat: 'YYYY/MM/DD',
      monthFormat: 'YYYY/MM',
      timeDebtDate: undefined,
      timePayDTStart: undefined,
      timePayDTEnd: undefined,
      checkDate: new Date(),
      NewDebtConfirmNo: ''
    }
  },
  computed: {
    sortOptions () {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    selectedRows () {
      return this.items.filter(item => item.selected)
    }
  },
  mounted () {
    this.PostReportQuerydetail()
  },
  methods: {
    moment,
    RecPerPage (SublayerPage) { // 組件筆數
      this.perPage = SublayerPage
    },
    date (data) {
      var date
      if (data !== null) {
        date = data.substr(0, 10)
      }
      return date
    },
    onDebtDate (date, dateString) { // 入帳日期
      this.timeDebtDate = date
      this.QueryDetail.DebtDate = dateString
    },
    onPayDTStart (date, dateString) { // 繳費時間(起)
      this.timePayDTStart = date
      this.QueryDetail.PayDTStart = dateString
    },
    onPayDTEnd (date, dateString) { // 繳費時間(迄)
      this.timePayDTEnd = date
      this.QueryDetail.PayDTEnd = dateString
    },
    oncheckDate (data, dateString) { // 繳費時間(迄)
      this.checkDate = data._d
    },
    onRowSelected (items) { // 單選
      const vm = this
      vm.selected = vm.selectedRows
      vm.TotalAmt = 0
      vm.ChargeTotalAmt = 0
      const num = vm.selected
      for (let index = 0; index < num.length; index++) {
        vm.TotalAmt += num[index].PayAmt
        vm.ChargeTotalAmt += num[index].PayCharge
      }
    },
    tbodyRowClass (item) { /* 0707 */
      if (item.selected) {
        return ['table-success']
      } else {
        return ['table-light']
      }
    },
    rowClicked (item) { /* 0707 */
      if (item.selected) {
        this.$set(item, 'selected', false)
        this.$set(item, 'No', false)
      } else {
        this.$set(item, 'selected', true)
        this.$set(item, 'No', true)
      }
    },
    selectAllRows () { // 全選
      const vm = this
      const data = vm.items
      if (vm.items.length !== vm.selected.length) {
        vm.TotalAmt = 0
        vm.ChargeTotalAmt = 0
        vm.selected = data
        for (let indexs = 0; indexs < data.length; indexs++) {
          if (data[indexs].FeeOrderStatus === 3) {
            vm.unselectThirdRow(data[indexs].SerialNo - 1)
          }
          vm.$set(data[indexs], 'selected', true)
          vm.$set(data[indexs], 'No', true)
          vm.TotalAmt += data[indexs].PayAmt
          vm.ChargeTotalAmt += data[indexs].PayCharge
        }
      }
    },
    clearSelected () { // 取消全選
      this.selectedRows.forEach((item) => {
        this.$delete(item, 'selected')
        this.$delete(item, 'No', false)
      })
      const vm = this
      vm.$refs.selectableTable.clearSelected()
      vm.selected = []
      vm.DebtData = {}
      vm.TotalAmt = 0
      vm.ChargeTotalAmt = 0
    },
    unselectThirdRow (data) {
      this.$refs.selectableTable.unselectRow(data)
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    PostReportQuerydetail () { // 查詢_銷帳明細表 B_API 018
      // 定義資料
      const vm = this
      var NewData
      // API預設資料
      const IdentityData = JSON.parse(sessionStorage.getItem('Identity'))
      // 查詢條件
      const DetailQuery = JSON.parse(sessionStorage.getItem('DetailQuery'))
      // 判斷帳號身分
      const Backend = md5('管理者')
      if (Backend === sessionStorage.getItem('Backend')) {
        vm.Backend = true
        if (!DetailQuery) { // 沒查詢條件，不打API
          vm.items = []
          return false
        } else {
          vm.QueryDetail = DetailQuery
          vm.timeDebtDate = (DetailQuery.timeDebtDate === 'undefined') ? undefined : moment(DetailQuery.timeDebtDate, vm.dateFormat)
          vm.timePayDTStart = (DetailQuery.timePayDTStart === 'undefined') ? undefined : moment(DetailQuery.timePayDTStart, vm.dateFormat)
          vm.timePayDTEnd = (DetailQuery.timePayDTEnd === 'undefined') ? undefined : moment(DetailQuery.timePayDTEnd, vm.dateFormat)
          NewData = Object.assign(IdentityData, DetailQuery)
        }
      } else {
        vm.ErrorModal('權限不足，無法使用此頁面')
        return false
      }
      // 呼叫API
      apiReportQuerydetail(NewData).then(
        res => {
          if (res !== undefined) {
            for (let index = 0; index < res.Data.length; index++) {
              const json = res.Data[index]
              json.SerialNo = index + 1
              json.No = false
            }
            vm.items = res.Data
            vm.totalRows = res.Data.length
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    InquireFeeitemQuery () { // 查詢條件
      // 定義資料
      var NewData
      const vm = this
      // 防呆
      if (vm.QueryDetail.PayApproach === '') {
        vm.ErrorModal('「繳費管道」為必選項目')
        return false
      }
      const IdentityData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData = Object.assign(IdentityData, vm.QueryDetail)
      delete NewData.timeDebtDate
      delete NewData.timePayDTEnd
      delete NewData.timePayDTStart
      // 紀錄查詢條件
      vm.QueryData = {}
      vm.QueryData = vm.QueryDetail
      vm.QueryData.timeDebtDate = (vm.timeDebtDate === undefined || vm.timeDebtDate === null) ? 'undefined' : vm.timeDebtDate
      vm.QueryData.timePayDTStart = (vm.timePayDTStart === undefined || vm.timePayDTStart === null) ? 'undefined' : vm.timePayDTStart
      vm.QueryData.timePayDTEnd = (vm.timePayDTEnd === undefined || vm.timePayDTEnd === null) ? 'undefined' : vm.timePayDTEnd
      sessionStorage.setItem('DetailQuery', JSON.stringify(vm.QueryData))
      // 呼叫API
      apiReportQuerydetail(NewData).then(
        res => {
          if (res !== undefined) {
            vm.ChargeTotalAmt = 0
            for (let index = 0; index < res.Data.length; index++) {
              const json = res.Data[index]
              json.SerialNo = index + 1
            }
            vm.items = res.Data
            vm.totalRows = res.Data.length
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    ClearCondition () { // 清除查詢條件
      const vm = this
      sessionStorage.removeItem('DetailQuery')
      vm.QueryDetail = {
        DebtConfirmNo: '',
        DebtDate: '',
        PayApproach: '',
        PayDTStart: '',
        PayDTEnd: ''
      }
      vm.timeDebtDate = undefined
      vm.timePayDTStart = undefined
      vm.timePayDTEnd = undefined
      vm.items = []
      vm.PostReportQuerydetail()
    },
    CheckReportDebtconfirm () { // 準備_入帳_銷帳明細表
      // 定義資料
      const vm = this
      vm.DebtData = [] // 每次入帳，先清空帶入的變數
      if (vm.selected.length === 0) {
        return false
      }
      vm.TotalAmt = 0
      // 選取的入帳資料，篩選出FeeOrderId，PayAmt
      for (let index = 0; index < vm.selected.length; index++) {
        if (vm.selected[index].FeeOrderStatus !== 3) {
          const SelectedData = vm.selected[index]
          var AddSelectedData = {}
          AddSelectedData.FeeOrderId = SelectedData.FeeOrderId
          AddSelectedData.PayAmt = SelectedData.PayAmt
          vm.DebtData[index] = AddSelectedData
          vm.TotalAmt = vm.TotalAmt + SelectedData.PayAmt
        } else {
          vm.unselectThirdRow(vm.selected[index].SerialNo - 1)
          vm.ErrorModal('資料已入帳')
          vm.clearSelected()
          return false
        }
      }
      $('#Debt').modal('show')
    },
    PostReportDebtconfirm () { // 入帳_銷帳明細表 B_API 019
      // 定義資料
      const vm = this
      $('#Debt').modal('hide')
      const NewDate = vm.checkDate.getFullYear() + '/' + (vm.checkDate.getMonth() + 1) + '/' + vm.checkDate.getDate()
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.TotalAmt = vm.TotalAmt
      NewData.PayApproach = vm.QueryDetail.PayApproach
      NewData.DebtRemark = vm.DebtRemark
      NewData.ReceiptDebt = vm.ReceiptDebt
      NewData.Data = vm.DebtData
      NewData.DebtDate = NewDate
      if (NewData.Data.length < 1) {
        vm.ErrorModal('請點選需入帳資料')
        return false
      }
      // 呼叫API
      apiReportDebtconfirm(NewData).then(
        res => {
          if (res !== undefined) {
            vm.NewDebtConfirmNo = res.Data[0].DebtConfirmNo
            $('#NewDebtConfirmNo').modal('show')
            vm.clearSelected()
            vm.ClearCondition()
            vm.PostReportQuerydetail()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostReportDetailexport () { // 匯出_銷帳明細表 B_API 020
      // 定義資料
      const vm = this
      $('#export').modal('hide')
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      if (!vm.Detailexport) {
        return false
      }
      NewData.DebtConfirmNo = vm.Detailexport
      // 呼叫API
      apiReportDetailexport(NewData).then(
        res => {
          if (res !== undefined) {
            const url = res.FileDir + '/' + res.FileName
            window.open(url)
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostReportChargerevise () { // 手續費變更 B_API 027
      const vm = this
      vm.Charge = []
      // 每次入帳，先清空帶入的變數
      // 選取的入帳資料，篩選出FeeOrderId，PayCharge
      for (let index = 0; index < vm.items.length; index++) {
        const ChargeData = vm.items[index]
        var AddChargeData = {}
        AddChargeData.FeeOrderId = ChargeData.FeeOrderId
        AddChargeData.PayCharge = ChargeData.PayCharge
        AddChargeData.DebtRemark = ChargeData.DebtRemark
        vm.Charge[index] = AddChargeData
      }
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.Data = vm.Charge
      // 呼叫API
      apiReportChargerevise(NewData).then(
        res => {
          if (res !== undefined) {
            vm.$bus.$emit('Modals', '變更成功')
            $('#CheckOk').modal('show')
            vm.clearSelected()
            vm.PostReportQuerydetail()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    GetCharge (data) {
      this.$refs.selectableTable.selectRow(data - 1)
    },
    ErrorModal (data) { // 錯誤彈跳視窗
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    }
  }
}
</script>

<style>
.cursor-pointer{
  cursor: pointer;
}
</style>
